// Kırpılan görseli eğitimin blob'una AYRI bir dosya olarak yükler.
//
// Kırpma eskiden base64 data URL'i kutuya gömüyordu: dosya hiçbir yere
// yüklenmiyor, kütüphanede görünmüyordu. Artık kırpılmış PNG, kaynak
// görselden farklı bir isimle `_LoadMediaFile` üzerinden aynı eğitimin
// altına yüklenir — orijinal kütüphane dosyası olduğu gibi kalır, kütüphanede
// ikisi de görünür.

import { _LoadMediaFile } from "../../../common/server_utils.es6";

// "…/foto.jpg?sig=…" → "foto-cropped-<ts>.png". data:/blob: URL'lerinde ya da
// isim çıkarılamazsa "image" tabanı kullanılır.
export function croppedFileName(sourceUrl, now = Date.now()) {
  let base = "image";
  if (typeof sourceUrl === "string" && /^https?:/i.test(sourceUrl)) {
    const last = sourceUrl.split(/[?#]/)[0].split("/").pop() || "";
    let decoded = last;
    try {
      decoded = decodeURIComponent(last);
    } catch (e) {
      // bozuk %-escape → ham segment
    }
    const stem = decoded.replace(/\.[^.]+$/, "").trim();
    if (stem) base = stem;
  }
  return `${base}-cropped-${now}.png`;
}

// Resolves with the uploaded file URL; rejects with an Error whose
// `userMessage` is the upload layer's user-facing sentence.
export function uploadCroppedBlob(blob, sourceUrl, upload = _LoadMediaFile) {
  const file = new File([blob], croppedFileName(sourceUrl), { type: blob.type || "image/png" });
  return new Promise((resolve, reject) => {
    upload(
      file,
      (_name, _mime, fileUrl) => {
        if (fileUrl) resolve(fileUrl);
        else reject(new Error("upload returned no fileUrl"));
      },
      undefined,
      (diagnostics) => {
        const err = new Error(
          (diagnostics && (diagnostics.userMessage || diagnostics.message)) || "upload failed"
        );
        err.userMessage = diagnostics && diagnostics.userMessage;
        reject(err);
      }
    );
  });
}
